package com.essntl.features.proposal.data.supabase.proposalhistory

import com.essntl.core.supabase.SupabaseDataSource
import com.essntl.features.proposal.data.supabase.proposal.ProposalDto
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ProposalHistoryDataSource::class])
internal class ProposalHistoryDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ProposalDto> {
    override val tableName: String = "proposal_history"
}
